import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gmax-dark-blue text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">GMAX Soluções</h3>
            <p className="mb-4">Soluções completas em facilities para sua empresa, com atendimento imediato e preço competitivo.</p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Contato</h3>
            <p className="mb-2">
              <span className="font-semibold">Email:</span> comercial@gmaxs.com.br
            </p>
            <p className="mb-2">
              <span className="font-semibold">Telefone:</span> (43) 99195-2859
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-gmax-blue transition-colors">Home</a></li>
              <li><a href="/servicos" className="hover:text-gmax-blue transition-colors">Serviços</a></li>
              <li><a href="/sobre" className="hover:text-gmax-blue transition-colors">Sobre Nós</a></li>
              <li><a href="/contato" className="hover:text-gmax-blue transition-colors">Contato</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p>&copy; {new Date().getFullYear()} GMAX Soluções. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
